
<style scoped>
  @import '../../../assets/css/eprendersdk.min.css';
</style>
<style lang="less">
  @import "./TakePicture.less";
</style>
<template>
  <div class="picture">
    <van-cell-group>
      <!--<van-cell title="IMEI" icon="setting-o" :value="nowImei" is-link @click="toChangeDevPageFn" />-->
      <van-cell title="IMEI" icon="setting-o" :value="nowImei" />
      <van-cell title="摄像头" icon="award-o" :value="cameraType" is-link @click="selectCameraFn" />
    </van-cell-group>
    <div class="page-btn">
      <van-button type="info" size="large" @click="takePictureFn">实时拍照</van-button>
      <van-button type="info" size="large" plain @click="queryPictureFn">历史照片</van-button>
    </div>
    <div class="picture-img" v-if="imgArray.length">
      <!--<img :src="imgUrl" alt="">-->
      <div class="picture-img-list" v-for="(item, index) in imgArray" :key="index">
        <h4>{{item.typeName}}</h4>
        <template v-if='item.type===4' >
          <div  id='demoImage' >
            <img :src="item.url" alt="" @load='change3DImg(item)' style="visibility: hidden;">
            <span class="fullScreen" @click.stop='fullScreenHandle(item,"change3DImg")' v-show='isangle'>
              <img src="../../../assets/images/fullScreen.png" alt="" srcset="">
            </span>
          </div>
        </template>
        <img :src="item.url" alt="" @click="previewImageFn(index)" v-else>
      </div>
    </div>
    <van-action-sheet
      v-model="showActionSheetCamera"
      title="请选择摄像头"
      round
      :actions="cameraTypeList"
      cancel-text="取消"
      @select="onSelectCameraFn"
    />
  </div>
</template>

<script>
import TakePicture from './TakePicture.js'
export default {
  ...TakePicture
}
</script>
